import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import Login from '@/components/Login'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login => require(['@/components/Login'], Login),
    },
    {
        path: '/AdminInformation',
        name: 'AdminInformation',
        component: AdminInformation => require(['@/components/Admin/AdminInformation'], AdminInformation),
        children: [
            { path: '/', name: 'AdminIndex', component: AdminIndex => require(['@/components/Admin/AdminIndex'], AdminIndex) ,meta: {PageType: 'Admin',}},
            { path: '/AdminIndex', name: 'AdminIndex', component: AdminIndex => require(['@/components/Admin/AdminIndex'], AdminIndex) ,meta: {PageType: 'Admin',}},
            { path: '/DeviceEntry', name: 'DeviceEntry', component: DeviceEntry => require(['@/components/Admin/DeviceEntry'], DeviceEntry) ,meta: {PageType: 'Admin',}},
            { path: '/DeviceDistribute', name: 'DeviceDistribute', component: DeviceDistribute => require(['@/components/Admin/DeviceDistribute'], DeviceDistribute) ,meta: {PageType: 'Admin',}},
            { path: '/DeviceType', name: 'DeviceType', component: DeviceType => require(['@/components/Admin/DeviceType'], DeviceType) },
            { path: '/AdminUserManage', name: 'AdminUserManage', component: AdminUserManage => require(['@/components/Admin/AdminUserManage'], AdminUserManage) ,meta: {PageType: 'Admin',}},
            { path: '/AdminTeacherManage', name: 'AdminTeacherManage', component: AdminTeacherManage => require(['@/components/Admin/AdminTeacherManage'], AdminTeacherManage) ,meta: {PageType: 'Admin',}},
            { path: '/AdminFinancialRecord', name: 'AdminFinancialRecord', component: AdminFinancialRecord => require(['@/components/Admin/AdminFinancialRecord'], AdminFinancialRecord) ,meta: {PageType: 'Admin',}},
        ],
        meta: {PageType: 'Admin',}
    },
    {
        path: '/UserPlatform',
        name: 'UserPlatform',
        component: UserPlatform => require(['@/components/User/UserPlatform'], UserPlatform),
        children: [
            { path: '/MyDevice', name: 'MyDevice', component: MyDevice => require(['@/components/User/MyDevice'], MyDevice) ,meta: {PageType: 'User',}},
            { path: '/OthersDevice', name: 'OthersDevice', component: OthersDevice => require(['@/components/User/OthersDevice'], OthersDevice) ,meta: {PageType: 'User',}},
            { path: '/UnassignedDevice', name: 'UnassignedDevice', component: UnassignedDevice => require(['@/components/User/UnassignedDevice'], UnassignedDevice) ,meta: {PageType: 'User',}},
            { path: '/PublicDevice', name: 'PublicDevice', component: PublicDevice => require(['@/components/User/PublicDevice'], PublicDevice) ,meta: {PageType: 'User',}}
        ],
        meta: {PageType: 'User',}
    }
  ]
})
// 挂载路由导航守卫
// to 将要访问的路径
// from 从哪个路径跳转而来
// next 放行 强制跳转函数
router.beforeEach((to, from, next) => {
    if (to.path == '/') {
        return next();
    }
    const tokenStr = window.sessionStorage.getItem('token');
    const TokenType = window.sessionStorage.getItem('TokenType')
    console.log(to.meta.PageType);
    if(!tokenStr) {
        return next('/')
    }
    else {
        if(to.meta.PageType == 'User') {
            if (TokenType != 'User') {
                return next('/')
            }
            else {
                return next()
            }
        }
        else if(to.meta.PageType == 'Admin') {
            if (TokenType != 'Admin') {
                return next('/')
            }
            else {
                return next()
            }
        }
        else {
            return next('/')
        }
    }
})

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
//push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}


export default router


// WEBPACK FOOTER //
// ./src/router/index.js